import { Modal, Box, Typography } from "@mui/material";
import { CustomTypography } from "../custom-typography/custom-typography";
import { SettingsDomain } from "./settings-domain/settings-domain";
import { CancelIcon } from "../../assets/icon";
import { SettingsCustomizeBot } from "./settings-customize-bot/settings-customize-bot";
import { SettingsAvatarUser } from "./settings-avatar-user/settings-avatar-user";
import { SettingsAvatarBot } from "./settings-avatar-bot/settings-avatar-bot";
import {
  modalBoxStyles,
  headerStyles,
  contentStyles,
  avatarsContainerStyles,
} from "./styles";
import useUserStore from "../../stores/userStore";

interface SettingsModalProps {
  open: boolean;
  onClose: () => void;
}

export const SettingsModal = ({ open, onClose }: SettingsModalProps) => {
  const { appVersion } = useUserStore();

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={modalBoxStyles}>
        <Box sx={headerStyles}>
          <CustomTypography fontSize={20} fontWeight={600} color="#FFFFFF">
            Settings
          </CustomTypography>
          <CancelIcon
            color="#FFFFFF"
            onClick={onClose}
            style={{ cursor: "pointer" }}
          />
        </Box>
        <Box sx={contentStyles}>
          <Box sx={avatarsContainerStyles}>
            <SettingsAvatarUser />
            <SettingsAvatarBot />
          </Box>
          <SettingsDomain />
          <SettingsCustomizeBot />
          <Box sx={{ paddingX: "16px" }}>
            <Typography sx={{ fontSize: "10px", color: "#a3a3a3" }}>
              Version: {appVersion}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};
